import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSlowSection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#737373",
		d: "M19 1.5a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1zM4.941 17.959v3.69h2.51L19.06 6.04V2.352h-2.51z"
	})
});
export default SvgSlowSection;
